import { Group, Text } from "@mantine/core";
import { FiSlash } from "react-icons/fi";

import classes from "./_css/SuspendedProfileBadge.module.css";

export function SuspendedProfileBadge() {
  return (
    <Group className={classes.badge} gap={4} wrap="nowrap">
      <FiSlash size={14} aria-hidden="true" />
      <Text className={classes.label}>利用停止中</Text>
    </Group>
  );
}
